import { useRecoilState} from 'recoil';
import { positionSchema } from '../utils/data';
import dp from '../assets/dp.png';
import goldStar from '../assets/gold-star.png';
import darkStar from '../assets/dark-star.png';
import employeeInfoAtom from '../atoms/employeeInfoAtom';

function Profile() {
    const [ employeeData, setEmployeeData ] = useRecoilState(employeeInfoAtom);

    function renderRating(n) {
        let rating = [];
        for(let i = 0; i < n; i++) {
            rating.push(<img src={goldStar} />)
        }
        for(let i = 0; i < 5-n; i++) {
            rating.push(<img src={darkStar} />)
        }
        return rating;
    }


    return(
        <div className='w-full'>
            <div className="text-4xl font-semibold pb-8 font-family-audiowide text-heading">PROFILE</div>
            <div className='grid grid-cols-4 gap-4'>
                <div className='col-span-3 px-4 border-2 border-gray-300'>
                    <div className='text-2xl py-2 '>BASIC INFO</div>
                    <div className='grid grid-cols-2'>
                        <div className=''>
                            <div className='flex justify-between mb-4'>
                                <div className=' '>First Name</div>
                                <div className='w-64 p-1 border border-gray-300 rounded-sm mr-8 '>{employeeData.name.split(' ')[0]}</div>
                            </div>
                            <div className='flex justify-between mb-4'>
                                <div className=' '>Address</div>
                                <div className='w-64 h-16 border border-gray-300 rounded-sm mr-8 '></div>
                            </div>
                        </div>
                        <div>
                            <div className='flex justify-between mb-4'>
                                <div className=' '>Last Name</div>
                                <div className='w-64 p-1 border border-gray-300 rounded-sm mr-8 '>{employeeData.name.split(' ')[1]}</div>
                            </div>
                            <div className='flex justify-between mb-4'>
                                <div className=' '>Contact Info</div>
                                <div className='w-64 h-16 border border-gray-300 rounded-sm mr-8 '>
                                    <div>{`Phone: 7277068914`}</div>
                                    <div>{`Email:    riffy@xyzac.com`}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className='text-2xl py-2 '>IMPORTANT DATES</div>
                    <div className='grid grid-cols-2 mt-2 mb-4'>
                        <div className='flex justify-between'>
                            <div className=' '>Anniversary</div>
                            <div className='w-64 p-1 border border-gray-300 rounded-sm mr-8 '>13th May</div>
                        </div>
                        <div className='flex justify-between'>
                            <div className=' '>DOB</div>
                            <div className='w-64 p-1 border border-gray-300 rounded-sm mr-8 '>15-09-1997</div>
                        </div>
                    </div>
                    <hr />
                    <div className='text-2xl py-2 '>TRAINING REVIEWS</div>
                    <div className=' '>
                        <div className='py-1'>Training 1: Well understood the concepts</div>
                        <div className='py-1'>Training 2: Good</div>
                        <div className='py-1 mb-2'>Training 3: Average</div>
                    </div>
                    <hr />
                    <div className='grid grid-cols-3'>
                        <div className='col-span-2 border-r border-gray-300 pb-4 '>
                            <div className='text-2xl py-2 '>Rewards</div>
                            <div className='py-1'>Best Employee Award - June, 2022</div>
                            <div className='py-1'>Employee of the Month - January, 2022</div>
                        </div>
                        <div className='pl-2 '>
                            <div className='text-2xl py-4 '>SHIFT PREFERENCE</div>
                            <div>04:00 PM - 12:00 PM</div>
                        </div>
                    </div>
                </div>
                <div className='col-span-1'>
                    <div><img alt='Display Image' src={dp} /></div>
                    <div className='text-2xl py-2 '>Customer</div>
                    <div className='flex justify-between pr-16'>
                        <div className='flex'>{renderRating(4)}</div>
                        <div className='  text-md'>4/5</div>
                    </div>
                    <div className='text-2xl py-2 '>Manager</div>
                    <div className='flex justify-between pr-16'>
                        <div className='flex'>{renderRating(4)}</div>
                        <div className='  text-md'>4/5</div>
                    </div>
                    <div className='text-2xl py-2 '>Reviews</div>
                    <div className='py-1 '>
                        <div>Hardworking and Motivating-</div>
                        <div>ABC, Service Manager</div>
                    </div>
                    <div className='py-1 '>
                        <div>Hardworking and Motivating-</div>
                        <div>ABC, Service Manager</div>
                    </div>
                    <div className='py-1 '>
                        <div>Hardworking and Motivating-</div>
                        <div>ABC, Service Manager</div>
                    </div>
                </div>
            </div>
            <div className='border-2 border-gray-300 p-4'>
                <div>
                    <div className='text-2xl py-2 '>TIME-OFF SCHEDULES</div>
                    <div className='py-1 '>Monday / 05-09-2022</div>
                    <div className='py-1 mb-4 '>Tuesday / 06-09-2022</div>
                </div>
                <hr />
                <div className='pb-4'>
                    <div className='text-2xl py-2 '>TRAININGS</div>
                    <div className='grid grid-cols-5 '>
                        <div className='col-span-2'>
                            <div>
                                <div className='text-lg font-semibold py-2 '>On-Board Trainings</div>
                                <div className='grid grid-cols-3 mb-2'>
                                    <div className='col-span-2'>On-Board Training - 1</div>
                                    <div className='bg-yellow-400 text-center font-semibold cursor-pointer mr-8'>Assign</div>
                                </div>
                                <div className='grid grid-cols-3 mb-2'>
                                    <div className='col-span-2'>On-Board Training - 1</div>
                                    <div className='bg-yellow-400 text-center font-semibold cursor-pointer mr-8'>Assign</div>
                                </div>
                                <div className='grid grid-cols-3 mb-2'>
                                    <div className='col-span-2'>On-Board Training - 1</div>
                                    <div className='bg-yellow-400 text-center font-semibold cursor-pointer mr-8'>Assign</div>
                                </div>
                                <div className='grid grid-cols-3 mb-2'>
                                    <div className='col-span-2'>On-Board Training - 1</div>
                                    <div className='bg-yellow-400 text-center font-semibold cursor-pointer mr-8'>Assign</div>
                                </div>
                                <div className='grid grid-cols-3 mb-2'>
                                    <div className='col-span-2'>On-Board Training - 1</div>
                                    <div className='bg-yellow-400 text-center font-semibold cursor-pointer mr-8'>Assign</div>
                                </div>
                                <div className='grid grid-cols-3 mb-2'>
                                    <div className='col-span-2'>On-Board Training - 1</div>
                                    <div className='bg-yellow-400 text-center font-semibold cursor-pointer mr-8'>Assign</div>
                                </div>
                            </div>
                            <div>
                                <div className='text-lg font-semibold py-2 '>Advanced Technical Trainings/Certifications</div>
                                <div className='grid grid-cols-3 mb-2'>
                                    <div className='col-span-2'>Certification Training</div>
                                    <div className='bg-teal-400 text-center font-semibold cursor-pointer mr-8'>Assign</div>
                                </div>
                                <div className='grid grid-cols-3 mb-2'>
                                    <div className='col-span-2'>Certification Training</div>
                                    <div className='bg-teal-400 text-center font-semibold cursor-pointer mr-8'>Assign</div>
                                </div>
                                <div className='grid grid-cols-3 mb-2'>
                                    <div className='col-span-2'>Certification Training</div>
                                    <div className='bg-teal-400 text-center font-semibold cursor-pointer mr-8'>Assign</div>
                                </div>
                            </div>
                        </div>
                        <div className='col-span-2'>
                            <div>
                                <div className='text-lg font-semibold py-2 '>Ongoing New Trainings</div>
                                <div className='grid grid-cols-3 mb-2'>
                                    <div className='col-span-2'>Ongoing Training - 1</div>
                                    <div className='bg-blue-400 text-center font-semibold cursor-pointer mr-8'>Assign</div>
                                </div>
                                <div className='grid grid-cols-3 mb-2'>
                                    <div className='col-span-2'>Ongoing Training - 1</div>
                                    <div className='bg-blue-400 text-center font-semibold cursor-pointer mr-8'>Assign</div>
                                </div>
                                <div className='grid grid-cols-3 mb-2'>
                                    <div className='col-span-2'>Ongoing Training - 1</div>
                                    <div className='bg-blue-400 text-center font-semibold cursor-pointer mr-8'>Assign</div>
                                </div>
                                <div className='grid grid-cols-3 mb-2'>
                                    <div className='col-span-2'>Ongoing Training - 1</div>
                                    <div className='bg-blue-400 text-center font-semibold cursor-pointer mr-8'>Assign</div>
                                </div>
                            </div>
                            {/* <div>
                                <div className='text-lg font-semibold py-2 '>Training Requests</div>
                                <div className='grid grid-cols-3 mb-2'>
                                    <div className='col-span-2'>Sunroof Troubleshooting</div>
                                    <div className='bg-green-400 text-center font-semibold cursor-pointer mr-8'>Approve</div>
                                </div>
                                <div className='grid grid-cols-3 mb-2'>
                                    <div className='col-span-2'>Sunroof Troubleshooting</div>
                                    <div className='bg-green-400 text-center font-semibold cursor-pointer mr-8'>Approve</div>
                                </div>
                            </div> */}
                        </div>
                        <div className='col-span-1'>
                            <div>
                                <div className='text-lg font-semibold py-2 '>Completed Trainings</div>
                                <div className='mb-2'>Training - 1</div>
                                <div className='mb-2'>Training - 1</div>
                                <div className='mb-2'>Training - 1</div>
                                <div className='mb-2'>Training - 1</div>
                                <div className='mb-2'>Training - 1</div>
                                <div className='mb-2'>Training - 1</div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div>
                    <div className='text-2xl py-2 '>CHECKOUT</div>
                    <div className='flex '>
                        <div className='text-lg font-semibold py-2 mr-16'>Equipment Reservations</div>
                        <div className='flex p-2 align-center'>
                            <div className='text-lg'>Equipment 1</div>
                            <div className='py-1 mx-2'><input type='checkbox' className='w-5 h-5' /></div>
                        </div>
                        <div className='flex p-2 align-center'>
                            <div className='text-lg'>Equipment 2</div>
                            <div className='py-1 mx-2'><input type='checkbox' className='w-5 h-5' /></div>
                        </div>
                        <div className='flex p-2 align-center'>
                            <div className='text-lg'>Equipment 3</div>
                            <div className='py-1 mx-2'><input type='checkbox' className='w-5 h-5' /></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Profile;